import { webApi } from "../../../../core/http/httpThunks";
import { EtfPerformanceResponse } from "../types";

export const getEtfPerformanceApi = (userId: string, symbol: string, endpoint: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<EtfPerformanceResponse>({
    method: "GET",
    url: "reporting/getsecurityinfo",
    params: {
      userId,
      symbol,
      endpoint
    },
  });
};

export default getEtfPerformanceApi;